module.exports = __webpack_public_path__ + "static/media/33.b6aaa11d.mp4";